import React from 'react';

const TitleContext = React.createContext({
  title: '',
});

export default TitleContext;
